// @ts-nocheck
/**
 * Copy-to-clipboard button — shows a checkmark for 1.5s after copy, or a
 * copy icon otherwise. `title` gives a native tooltip.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CopyButton = ({ text, style = {}, className = '' }: any) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      toast.error('Failed to copy text');
    }
  };

  if (!text) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      className={`m-0 ${className}`}
      onClick={copyToClipboard}
      style={{ ...style }}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
    </Button>
  );
};

export default CopyButton;
